module.exports = __webpack_public_path__ + "static/andrew-carnegie-eeda6df1e51cb38ae7162566e63645b0.jpg";